import { DeleteAccountPage } from "../components"

export default DeleteAccountPage
